import {
  SUPER_ADMIN_REFERRALS,
  SUPER_ADMIN_REFREES,
  SUPER_ADMIN_VENDOR_REFERRALS,
  SUPER_ADMIN_SALES_REFERRALS,
  SUPER_ADMIN_AFFILIATES_REFERRALS,
  SUPER_ADMIN_PARTNERS_REFERRALS,
  SUPER_ADMIN_REFERRAL_CODES,
  SET_REFERRAL_AND_CASHBACK,
} from "../../types";

const initialState = {
  refrees: [],
  referrals: [],
  vendorReferrals: [],
  salersReferrals: [],
  affiliatesReferrals: [],
  partnersReferrals: [],
  referralCodes: [],
  referralRewardAndCashback: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SUPER_ADMIN_REFREES:
      return {
        ...state,
        refrees: action.payload,
      };
    case SUPER_ADMIN_REFERRALS:
      return {
        ...state,
        referrals: action.payload,
      };
    case SUPER_ADMIN_VENDOR_REFERRALS:
      return {
        ...state,
        vendorReferrals: action.payload,
      };
    case SUPER_ADMIN_SALES_REFERRALS:
      return {
        ...state,
        salersReferrals: action.payload,
      };
    case SUPER_ADMIN_AFFILIATES_REFERRALS:
      return {
        ...state,
        affiliatesReferrals: action.payload,
      };
    case SUPER_ADMIN_PARTNERS_REFERRALS:
      return {
        ...state,
        partnersReferrals: action.payload,
      };
    case SUPER_ADMIN_REFERRAL_CODES:
      return {
        ...state,
        referralCodes: action.payload,
      };
    case SET_REFERRAL_AND_CASHBACK:
      return {
        ...state,
        referralRewardAndCashback: action.payload,
      };
    default:
      return state;
  }
}
